
  import { CARDS } from '~/constants/cards';

  export default {
    computed: {
      card () {
        return this.$store.state.products.current;
      },
      creditLimit () {
        return this.$n(CARDS.creditLimit, 'currencyRound');
      },
      stampDuty () {
        return this.$n(CARDS.stampDuty, 'currencyRound');
      }
    }
  };
